import { Location } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { MainMenu, Menu, SideBar } from '../../../../shared/models/models';
import { DataService } from '../../../../shared/data/data.service';
import { CommonService } from '../../../../shared/common/common.service';
import { Router } from '@angular/router';
import { SideBarService } from '../../../../shared/side-bar/side-bar.service';
import { routes } from '../../../../shared/routes/routes';
import { BreakpointObserver } from '@angular/cdk/layout';
import { SettingService } from '../../../../shared/settings/settings.service';
import { ModalService } from '../../services/modal.service';
import { LoginModalComponent } from '../../../../shared/components/login-modal/login-modal.component';
import { AuthService } from '../../../../shared/core/service/auth.service';


@Component({
  selector: 'app-default-header',
  templateUrl: './default-header.component.html',
  styleUrl: './default-header.component.scss',
  standalone: false
})
export class DefaultHeaderComponent {

  // Country/Currency dropdown functionality
  supportedInfo: Array<{ id: number; currency: string; hotelLanguage?: string; country: string; isDefault?: boolean }> = [];
  selectedCountryId: number | null = null;
  hotelLanguages: Array<{ languageCode?: string; language_code?: string; languageName?: string; language_name?: string }> = [];

  get selectedCountryLabel(): string {
    const found = this.supportedInfo.find(i => i.id === this.selectedCountryId);
    if (!found) return 'Select';
    const langName = this.getHotelLanguageName(found.hotelLanguage as any);
    return `${found.currency}${langName ? ' • ' + langName : ''}`;
  }

  onCountryChangeDropdown(selectedId: number) {
    this.selectedCountryId = selectedId;
    const selectedObj = this.supportedInfo.find(i => i.id === selectedId);
    if (selectedObj) {
      localStorage.setItem('selectedCountryInfo', JSON.stringify(selectedObj));
      this.closeMenu();
          this.router.navigate(['/home']);
    }
  }

  header: Array<SideBar> = [];
  base = 'dashboard';
  public page = '';
  last = '';
  isMobileMenu = false;
  isDropdownOpen = false;
  isDropdownOpen1 = false;
  isHovered = false;
  ishome2 = false;
  isheaderFour = false;
  show = false;
  isFixed = false;
  isdark = true;
  islight = false;
  themeColor = '2';

  // App banner properties
  isAppBannerClosed = true;

  public routes = routes;
  side_bar_data: MainMenu[] = [];
  password: boolean[] = [false, false]; // Add more as needed

  togglePassword(index: number): void {
    this.password[index] = !this.password[index];
  }
  @HostListener('window:scroll', [])
  onWindowScroll() {
    // Add a fixed class when the scroll position is greater than 50px
    this.isFixed = window.pageYOffset > 50;
  }
  mainMenus = [
    { title: 'Menu 1', separateRoute: false },
    { title: 'Menu 2', separateRoute: false },
    { title: 'Menu 3', separateRoute: false },
  ];
  openDropdownIndex: number | null = null;
  constructor(
  private readonly data: DataService,
  private readonly sideBar: SideBarService,
  private readonly common: CommonService,
  private readonly router: Router,
  private readonly location: Location,
  private readonly breakpointObserver: BreakpointObserver,
    public settings: SettingService,
    public modalService: ModalService,
    public readonly authService: AuthService
  ) {
    this.common.base.subscribe((res: string) => {
      this.base = res;
    });
    this.common.page.subscribe((res: string) => {
      this.page = res;
    });
    this.common.page.subscribe((res: string) => {
      this.last = res;
    });
    this.settings.themeColor.subscribe((res: string) => {
      this.themeColor = res;
    });
  }


  elem = document.documentElement;
  fullscreen() {
    if (!document.fullscreenElement) {
      this.elem.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
  }
  public togglesMobileSideBar(): void {
    this.sideBar.switchMobileSideBarPosition();
  }

  public expandSubMenus(menu: Menu): void {
    sessionStorage.setItem('menuValue', menu.menuValue);
    this.side_bar_data.forEach((mainMenus: MainMenu) => {
      mainMenus.menu.forEach((resMenu: Menu) => {
        // collapse other submenus which are open
        if (resMenu.menuValue === menu.menuValue) {
          menu.showSubRoute = !menu.showSubRoute;
          if (menu.showSubRoute === false) {
            sessionStorage.removeItem('menuValue');
          }
        } else {
          resMenu.showSubRoute = false;
        }
      });
    });
  }

  navigateOrReload(fragment: string) {
    const currentUrl = this.location.path(false).split('#')[0];
    // routes is imported from shared/routes/routes
    const indexUrl = this.router.createUrlTree([routes.index]).toString();
    if (currentUrl === indexUrl || currentUrl === '/' || currentUrl === '') {
      window.location.hash = '#' + fragment;
    } else {
      this.router.navigate([routes.index], { fragment });
    }
  }
  miniSideBarBlur(position: string) {
    if (position === 'over') {
      this.sideBar.expandSideBar.next(true);
    } else {
      this.sideBar.expandSideBar.next(false);
    }
  }

  miniSideBarFocus(position: string) { this.miniSideBarBlur(position); }
  public submenus = false;
  openSubmenus() {
    this.submenus = !this.submenus;
  }
  ngOnInit(): void {
  // Load language catalog for name resolution
  this.data.getHotelLanguages().subscribe(langs => { this.hotelLanguages = langs || []; });
    this.breakpointObserver.observe(['(max-width: 991px)']).subscribe(result => {
      this.isMobileMenu = result.matches;
    });
    const themeColor = localStorage.getItem('themeColor') || '2';
    this.settings.changeThemeColor(themeColor);

    // Check if app banner was previously closed
    // const bannerClosed = localStorage.getItem('appBannerClosed');
    // this.isAppBannerClosed = bannerClosed === 'true';

    // Initialize supported countries/currencies
    this.data.getSupportedInfo().subscribe((info: any[]) => {
      this.supportedInfo = info;
      let selectedObj: any = null;
      const stored = localStorage.getItem('selectedCountryInfo');
      if (stored) {
        try {
          const parsed = JSON.parse(stored);
          selectedObj = info.find(i => i.id === parsed.id) || null;
        } catch { /* ignore */ }
      }
      if (!selectedObj) {
        // Prefer backend default if present
        selectedObj = info.find(i => i.isDefault) || info[0];
      }
      if (selectedObj) {
        this.selectedCountryId = selectedObj.id;
        localStorage.setItem('selectedCountryInfo', JSON.stringify(selectedObj));

      }
    });
    this.data.getAllCommissions().subscribe(commissions => {
    localStorage.setItem('commissions', JSON.stringify(commissions));
    });
  }

  getHotelLanguageName(code?: string): string | null {
    if (!code) return null;
    const rec = this.hotelLanguages.find(l => (l.languageCode || (l as any).language_code) === code);
    return rec ? (rec.languageName || (rec as any).language_name || null) : null;
  }
  closeMenu(): void {
    this.isMobileMenu = false; // Removes the `mean-container` class
    this.show = false;
  }
  addmenu(): void {
    this.isMobileMenu = true;
    this.show = true;
  }
  openSubMenu(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
    this.openDropdownIndex = null;
  }
  toggleSubMenu(index: number): void {
    // If the clicked menu is already open, close it
    this.openDropdownIndex = this.openDropdownIndex === index ? null : index;
    this.isDropdownOpen = false;
  }
  darkMode(): void {
    this.isdark = !this.isdark;
    this.islight = !this.islight;
  }

  onSubmit0(): void {
    this.router.navigateByUrl('/index')
  }


  openModel() {
    this.modalService.open(LoginModalComponent);
  }

  logout() {
    this.authService.logout();
  }

  // APK Download functionality
  downloadAPK() {
    // Analytics or tracking can be added here
    console.log('Android APK download initiated');

    // Create a download link and trigger it
    const link = document.createElement('a');
    link.href = 'assets/apk/bookatravel.apk';
    link.download = 'BookATravel.apk';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  // Close app banner functionality
  closeAppBanner() {
    this.isAppBannerClosed = true;
    // Optional: Store in localStorage to remember user's choice
    localStorage.setItem('appBannerClosed', 'true');
  }
}
